import axios from 'axios'

import store from 'stateManagement/store'
import {enqueueSnackBar} from 'stateManagement/slices/notificationsSlice'
import Auth from 'core/services/auth/Auth'
import Config from 'core/config'
import history from 'core/services/history'
import localize from 'utils/localizer'
import {paths, severityTypes} from 'core/constants'

const logoutErrorCustomMessage = {
  message: localize('logout.errorMessage'),
  key: new Date().getTime() + Math.random(),
  options: {
    variant: severityTypes.ERROR,
  },
}

const instanceAxios = axios.create({
  baseURL: Config.baseUrlApi,
  headers: {'Content-Type': 'application/json'},
})

instanceAxios.interceptors.request.use(config => {  
  const token = Auth.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
    const currentProfileId = Auth.getCurrentProfileId()
    if(currentProfileId) {
      config.headers['currentProfileId'] = currentProfileId;
    }
  }
  return config
})


instanceAxios.interceptors.response.use(
  config => config,
  error => {
    /*
     * Intercept token errors, remove store session and logout
     */
    const errorResponse = error.response?.data?.message
    const signature = /verification|failed/gi
    const expiredToken = /Expired token/gi
    const unexpectedToken = /Unexpected|token/gi

    if (
      signature.test(errorResponse) ||
      expiredToken.test(errorResponse) ||
      unexpectedToken.test(errorResponse)
    ) {
      history.push(paths.LOGOUT)
      store.dispatch(enqueueSnackBar(logoutErrorCustomMessage))
      return
    }

    /*
     * Support to catch errors on responseType: Blob on error
     */
    if (
      error.request.responseType === 'blob' &&
      error.response.data instanceof Blob &&
      error.response.data.type &&
      error.response.data.type.toLowerCase().indexOf('json') !== -1
    ) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = () => {
          error.response.data = JSON.parse(reader.result)
          resolve(Promise.reject(error))
        }

        reader.onerror = () => {
          reject(error)
        }

        reader.readAsText(error.response.data)
      })
    }

    return Promise.reject(error)
  },
)

const instanceAxiosSecurity = axios.create({
  baseURL: Config.baseUrlApiSecurity,
  headers: {'Content-Type': 'application/json'},
})

instanceAxiosSecurity.interceptors.request.use(config => {  
  const token = Auth.getOcaToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

instanceAxiosSecurity.interceptors.response.use(
  config => config,
  error => {
    /*
     * Intercept token errors, remove store session and logout
     */
    const errorResponse = error.response?.data?.message
    const signature = /verification|failed/gi
    const expiredToken = /Expired token/gi
    const unexpectedToken = /Unexpected|token/gi

    if (
      signature.test(errorResponse) ||
      expiredToken.test(errorResponse) ||
      unexpectedToken.test(errorResponse)
    ) {
      history.push(paths.LOGOUT)
      store.dispatch(enqueueSnackBar(logoutErrorCustomMessage))
      return
    }

    /*
     * Support to catch errors on responseType: Blob on error
     */
    if (
      error.request.responseType === 'blob' &&
      error.response.data instanceof Blob &&
      error.response.data.type &&
      error.response.data.type.toLowerCase().indexOf('json') !== -1
    ) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = () => {
          error.response.data = JSON.parse(reader.result)
          resolve(Promise.reject(error))
        }

        reader.onerror = () => {
          reject(error)
        }

        reader.readAsText(error.response.data)
      })
    }

    return Promise.reject(error)
  },
)

const instanceAxiosCuadrilla = axios.create({
  baseURL: Config.baseUrlApiCuadrilla,
  headers: {'Content-Type': 'application/json'},
})

instanceAxiosCuadrilla.interceptors.request.use(config => {  
  const token = Auth.getOcaToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

instanceAxiosCuadrilla.interceptors.response.use(
  config => config,
  error => {
    /*
     * Intercept token errors, remove store session and logout
     */
    const errorResponse = error.response?.data?.message
    const signature = /verification|failed/gi
    const expiredToken = /Expired token/gi
    const unexpectedToken = /Unexpected|token/gi

    if (
      signature.test(errorResponse) ||
      expiredToken.test(errorResponse) ||
      unexpectedToken.test(errorResponse)
    ) {
      history.push(paths.LOGOUT)
      store.dispatch(enqueueSnackBar(logoutErrorCustomMessage))
      return
    }

    /*
     * Support to catch errors on responseType: Blob on error
     */
    if (
      error.request.responseType === 'blob' &&
      error.response.data instanceof Blob &&
      error.response.data.type &&
      error.response.data.type.toLowerCase().indexOf('json') !== -1
    ) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = () => {
          error.response.data = JSON.parse(reader.result)
          resolve(Promise.reject(error))
        }

        reader.onerror = () => {
          reject(error)
        }

        reader.readAsText(error.response.data)
      })
    }

    return Promise.reject(error)
  },
)

/*Nueva api*/
const instanceAxiosCheckList = axios.create({
  baseURL: Config.baseUrlApiCheckList,
  headers: {'Content-Type': 'application/json'},
})

instanceAxiosCheckList.interceptors.request.use(config => {  
  const token = Auth.getOcaToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

instanceAxiosCheckList.interceptors.response.use(
  config => config,
  error => {
    /*
     * Intercept token errors, remove store session and logout
     */
    const errorResponse = error.response?.data?.message
    const signature = /verification|failed/gi
    const expiredToken = /Expired token/gi
    const unexpectedToken = /Unexpected|token/gi

    if (
      signature.test(errorResponse) ||
      expiredToken.test(errorResponse) ||
      unexpectedToken.test(errorResponse)
    ) {
      history.push(paths.LOGOUT)
      store.dispatch(enqueueSnackBar(logoutErrorCustomMessage))
      return
    }

    /*
     * Support to catch errors on responseType: Blob on error
     */
    if (
      error.request.responseType === 'blob' &&
      error.response.data instanceof Blob &&
      error.response.data.type &&
      error.response.data.type.toLowerCase().indexOf('json') !== -1
    ) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = () => {
          error.response.data = JSON.parse(reader.result)
          resolve(Promise.reject(error))
        }

        reader.onerror = () => {
          reject(error)
        }

        reader.readAsText(error.response.data)
      })
    }

    return Promise.reject(error)
  },
)
/*Hasta aqui*/

export {instanceAxios, instanceAxiosSecurity,instanceAxiosCuadrilla,instanceAxiosCheckList}
